export const TIP_MODES = [
  "none",
  "fivePercent",
  "tenPercent",
  "twentyPercent",
  "custom",
] as const;
export type TipMode = (typeof TIP_MODES)[number];
